/**
 * 设置135编辑器
 */
"use strict";
angular.module("setting135EditorModule", []).
directive("setting135Editor", ["$q", function($q) {
    return {
        restrict: "A",
        replace: false,
        templateUrl: "./components/util/ueditor/135editor/setting135Editor/setting135Editor_tpl.html",
        transclude: true,
        scope: {
            is135Editor: "=",
            to135: "&",
            toCommon: "&"
        },
        link: function(scope, $elem, $attrs) {
            init();
            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function init() {
                scope.status = {
                    showLeft: false,
                    showRight: false,
                    localIs135Editor: localStorage["is135Editor"] === "true" ? true : false
                };
                scope.status.curis135 = scope.status.localIs135Editor;
                watcherIs135Editor().then(function() {

                }, function() {

                });
            }
            /**
             * [takeUp description] 收起135编辑器
             * @return {[type]} [description]
             */
            scope.takeUp = function() {
                scope.status.curis135 = false;
                var ueditorScope = $elem.children().eq(1).data().$isolateScope;
                $elem.children().eq(1).remove();
                ueditorScope.$destroy();
                scope.toCommon();
            };
            /**
             * [alwaysExpanded description] 总是展开
             * @return {[type]} [description]
             */
            scope.alwaysExpanded = function($event) {
                if (!scope.status.localIs135Editor) {
                    localStorage["is135Editor"] = "true";
                } else {
                    localStorage["is135Editor"] = "false";
                    scope.takeUp();
                }
                scope.status.localIs135Editor = !scope.status.localIs135Editor;
                $($event.target).parent().css("width", 0);
                setTimeout(function() {
                    $($event.target).parent().css("width", "");
                },1000);
            };
            /**
             * [goTo135Editor description] 进入图文排版模式
             * @return {[type]} [description]
             */
            scope.goTo135Editor = function() {
                scope.status.curis135 = true;
                var ueditorScope = $elem.children().eq(1).data().$isolateScope;
                $elem.children().eq(1).remove();
                ueditorScope.$destroy();
                scope.to135();
            };
            /**
             * [watcherIs135Editor description] 初始化监控135编辑器配置是否生效
             * @return {[type]} [description]
             */
            function watcherIs135Editor() {
                var deffer = $q.defer();
                var myWatcher = scope.$watch("is135Editor", function(newV, oldV) {
                    if (oldV === undefined && newV === true) {
                        deffer.resolve();
                        scope.status.is135Editor = true;
                        myWatcher();
                    } else if (oldV === undefined && newV === undefined) {

                    } else {
                        scope.status.is135Editor = false;
                        deffer.reject();
                        myWatcher();
                    }
                });
                return deffer.promise;
            }
        }
    };
}]);